import React from 'react';

const AttendeeFormCard = ({
  delegates,
  attendeeTypes,
  titles,
  genders,
  validationErrors,
  onFieldChange,
  onSubmit,
  packageData,
  onRemoveDelegate,
  event,
}) => {
  const isConference = event?.event_type?.toLowerCase() === 'conference';
  return (
    <div id="ticket-attendee-form" className="ticket-card">
      <div className="ticket-attendee-list">
        {delegates.map((delegate, index) => (
          <div className="ticket-card ticket-card--muted" key={index}>
            <div className="ticket-attendee-card__delegate-header">
              <div className="ticket-attendee-card__delegate-title">
                Attendee {index + 1}
              </div>
              {index > 0 && (
                <button
                  type="button"
                  className="ticket-attendee-card__remove-btn"
                  onClick={() => onRemoveDelegate && onRemoveDelegate(index)}
                >
                  ×
                </button>
              )}
            </div>
            <div className="ticket-attendee-grid">
              <div className="ticket-input-group">
                <label className="ticket-input-label">Title</label>
                <select
                  className="ticket-select"
                  value={delegate.title}
                  onChange={(e) => onFieldChange(index, 'title', e.target.value)}
                >
                  <option value="">Please select</option>
                  {titles.map((t, i) => (
                    <option key={i}>{t}</option>
                  ))}
                </select>
              </div>

              <div className="ticket-input-group">
                <label className="ticket-input-label">Full Name</label>
                <input
                  className={
                    validationErrors[`${index}-name`]
                      ? 'ticket-input ticket-input--error'
                      : 'ticket-input'
                  }
                  type="text"
                  placeholder="Please Enter Full Name"
                  value={delegate.name}
                  onChange={(e) => onFieldChange(index, 'name', e.target.value)}
                />
                {validationErrors[`${index}-name`] && (
                  <div className="ticket-input-error-message">
                    {validationErrors[`${index}-name`]}
                  </div>
                )}
              </div>

              <div className="ticket-input-group">
                <label className="ticket-input-label">Gender</label>
                <select
                  className="ticket-select"
                  value={delegate.gender}
                  onChange={(e) => onFieldChange(index, 'gender', e.target.value)}
                >
                  <option value="">Please select</option>
                  {genders.map((g, i) => (
                    <option key={i}>{g}</option>
                  ))}
                </select>
              </div>

              <div className="ticket-input-group">
                <label className="ticket-input-label">Email Address</label>
                <input
                  className={
                    validationErrors[`${index}-email`]
                      ? 'ticket-input ticket-input--error'
                      : 'ticket-input'
                  }
                  type="email"
                  placeholder="Email Address"
                  value={delegate.email}
                  onChange={(e) => onFieldChange(index, 'email', e.target.value)}
                />
                {validationErrors[`${index}-email`] && (
                  <div className="ticket-input-error-message">
                    {validationErrors[`${index}-email`]}
                  </div>
                )}
              </div>

              <div className="ticket-input-group">
                <label className="ticket-input-label">Phone Number</label>
                <input
                  className={
                    validationErrors[`${index}-phone`]
                      ? 'ticket-input ticket-input--error'
                      : 'ticket-input'
                  }
                  type="text"
                  placeholder="Phone Number (10 digits)"
                  value={delegate.phone}
                  onChange={(e) => onFieldChange(index, 'phone', e.target.value)}
                />
                {validationErrors[`${index}-phone`] && (
                  <div className="ticket-input-error-message">
                    {validationErrors[`${index}-phone`]}
                  </div>
                )}
              </div>

              {isConference && (
                <div className="ticket-input-group">
                  <label className="ticket-input-label">IEEE Number (Optional)</label>
                  <input
                    className={
                      validationErrors[`${index}-ieee`]
                        ? 'ticket-input ticket-input--error'
                        : 'ticket-input'
                    }
                    type="text"
                    placeholder="IEEE Number (8 digits)"
                    value={delegate.ieee}
                    onChange={(e) => onFieldChange(index, 'ieee', e.target.value)}
                  />
                  {validationErrors[`${index}-ieee`] && (
                    <div className="ticket-input-error-message">
                      {validationErrors[`${index}-ieee`]}
                    </div>
                  )}
                </div>
              )}

              {isConference && (
                <div className="ticket-input-group">
                  <label className="ticket-input-label">Delegation</label>
                  <select
                    className="ticket-select"
                    value={delegate.delegation}
                    onChange={(e) => onFieldChange(index, 'delegation', e.target.value)}
                  >
                    {attendeeTypes.map((type, i) => (
                      <option key={i}>{type}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="ticket-purchase-button-container">
        <button
          type="button"
          className="ticket-purchase-button"
          onClick={onSubmit}
        >
          Purchase Package
        </button>
      </div>
    </div>
  );
};

export default AttendeeFormCard;
